//import jqueryValidation from 'jquery-validation';

export default {
    init() {
      //console.log('CHECKOUT');

      $('#createaccount-mirror').change(function () {
          if ($(this).is(':checked')) {
              $('#createaccount').trigger('click');
              return;
          }
          $('#createaccount').trigger('click');
      });

      const couponToggle = $('.woocommerce-form-coupon-toggle');
      const coupon = $('.checkout_coupon.woocommerce-form-coupon');
      coupon.insertAfter('.shop_table.woocommerce-checkout-review-order-table');
      couponToggle.insertAfter('.shop_table.woocommerce-checkout-review-order-table');

      const couponDiscount = $('.woocommerce-checkout-review-order-table tr.fee');
      couponDiscount.insertAfter('.woocommerce-checkout-review-order-table tr.cart-discount');
      //const discount = $('.checkout_coupon.woocommerce-form-coupon');

      //couponToggle.insertAfter('.shop_table.woocommerce-checkout-review-order-table');

      // SELECT2 COUNTRY FIX
      //   $('#billing_country').select2('destroy');
      //   $('#shipping_country').select2('destroy');

      // $('tr.shipping.paczkomaty-shipping td').prepend('<span id="parcel"></span>')

    //   $(document.body).on('change',"#paczkomat_name",function (e) {
    //     console.log('WYBRANO PACZKOMAT!');
    //     const parcel = $('#paczkomat_name').val();
    //     const parcelButton =  $('tr.shipping.paczkomaty-shipping td div a');
    //     console.log(parcel);
    //     console.log(parcelButton);
    //     parcelButton.html('<span>Wybrano paczkomat:</span> ' + parcel + ' <strong>(zmień)</strong>')
    //   });

      // $("body").bind("DOMSubtreeModified", function() {
      //   console.log('WYBRANO PACZKOMAT 1');
      //   const parcel = $('#paczkomat_name').val();
      //   const parcelButton =  $('tr.shipping.paczkomaty-shipping td div a');
      //   console.log(parcel);
      //   console.log(parcelButton);
      //   parcelButton.html('<span>Wybrano paczkomat:</span> ' + parcel + ' <strong>(zmień)</strong>')
      //   // if ($("#map-list-flex").length) {
      //   //   $("#map-list-flex a.select-link").on('click', function() {
      //   //     console.log('WYBRANO PACZKOMAT 2');
      //   //     const parcel = $(this).parents('.popup-container').children('.point-wrapper').children('p');
      //   //     const parcelButton =  $('tr.shipping.paczkomaty-shipping td div a');
      //   //     console.log(parcel);
      //   //     console.log(parcelButton);
      //   //     parcelButton.html('<span>Wybrano paczkomat:</span> ' + parcel[0].innerHTML + ' <strong>(zmień)</strong>');
      //   //   });
      //   // }
      // });


      // CUSTOM CHECKOUT - PACZKOMAT VALIDATION
      // $(document.body).on( 'change', 'input.shipping_method', function() {
      //   //console.log('CHANGE SHIPPING');
      
      //   const parcelInput = $('#order_paczkomat_valid');
      //   const selectedParcel = parcelInput.data('selected');
      //   // eslint-disable-next-line no-inner-declarations
      //   function setLabel() {
      //     $('#open-geowidget').html('<img id="inpost-ico" src="/wp-content/themes/instytut-kawy/resources/assets/images/paczkomat.png"><span>Wybrano Paczkomat:</span> ' + selectedParcel + ' <strong>(zmień)</strong>');
      //   }
      //   function setLabelTimeout() {
      //     //console.log('TIMEOUT');
      //     setTimeout(() => {
      //       setLabel();
      //     }, 1900);
      //   }
      //   if ($('#shipping_method_0_flexible_shipping_single9').is(':checked')) {
      //     //console.log('CHANGE SHIPPING > PACZKOMATY');
      //     if(parcelInput.hasClass('selected')) {
      //       //console.log('CHANGE SHIPPING > PACZKOMAT JUŻ WYBRANO');
      //       //console.log(selectedParcel);
      //       parcelInput.val(selectedParcel);
      //       setLabelTimeout();
      //     } else {
      //       //console.log('CHANGE SHIPPING > PACZKOMAT NIE! WYBRANO');
      //       parcelInput.val('');
      //     }
      //   } else {
      //     //console.log('CHANGE SHIPPING > INNY');
      //     parcelInput.val('nie dotyczy');
      //   }
      // });

    },
}



// WEBPACK FOOTER //
// ./scripts/routes/checkout.js